import * as React from 'react';
import { ComponentProps } from 'react';

import { SlTabPanel } from '@shoelace-style/shoelace/dist/react';

type TabPanelProps = ComponentProps<typeof SlTabPanel>;

export function TabPanel({ children, ...props }: TabPanelProps) {
  return <SlTabPanel {...props}>{children}</SlTabPanel>;
}
